import {
  SALES_ORDERS,
  ADD_SALES_ORDER,
  ADD_SALES_ORDER_ERROR,
  SALES_ORDER_DETAILS,
  DELETE_SALES_ORDER,
  UPDATE_SALES_ORDER,
  SALES_ORDER_REPORTS,
} from "../types/SalesOrderType";
import { message } from "antd";

const initialState = {
  list: null,
  currentOrder: null,
  reports: null,
  pagination: null,
  loading: false,
  error: null,
};

const salesOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SALES_ORDERS:
      return {
        ...state,
        list: action.payload.orders || [],
        pagination: action.payload.pagination || null,
        loading: false,
      };

    case ADD_SALES_ORDER:
      if (!Array.isArray(state.list)) {
        state.list = [];
      }
      const list = [...state.list];
      list.push(action.payload);
      return { ...state, list, loading: false };

    case SALES_ORDER_DETAILS:
      return { ...state, currentOrder: action.payload.order, loading: false };

    case UPDATE_SALES_ORDER:
      const updatedList = state.list?.map((order) =>
        order.id === action.payload.id ? action.payload : order
      ) || [];
      return {
        ...state,
        list: updatedList,
        currentOrder: action.payload,
        loading: false,
      };

    case DELETE_SALES_ORDER:
      const filterOrders = state.list?.filter(
        (order) => order.id !== parseInt(action.payload) && order
      ) || [];
      return { ...state, list: filterOrders, loading: false };

    case SALES_ORDER_REPORTS:
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.payload.reportType]: action.payload.data,
        },
        loading: false,
      };

    case ADD_SALES_ORDER_ERROR:
      message.error(action.payload);
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
};

export default salesOrderReducer;
